import MaterialList, { ListProps } from '@mui/material/List';

export function List(props: ListProps) {
    return <MaterialList data-testid={'List-container'} {...props} />;
}

export default List;
